import { SedesTramitesUAC } from "./sedesTramitesUAC.model";


export class TramiteUACModel {
    public nombre: string;
    public idTramite: string;
    public turnoActual: string;
    public maximoTurnos: string;
    public estado: string;
    public letraTurno: string;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;
    public descripcion: string;
    public diasTramite: number;
    public sedesTramites :SedesTramitesUAC[];

}